import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/svg/announcement.svg';

const _withScopeId = n => (_pushScopeId("data-v-0ed1d2d3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "notice"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");

  const _component_my_image = _resolveComponent("my-image");

  const _component_van_swipe_item = _resolveComponent("van-swipe-item");

  const _component_van_swipe = _resolveComponent("van-swipe");

  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.noticeList.length && $setup.props.showNotice ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_van_notice_bar, {
    scrollable: "",
    color: "#000000",
    background: "#ffffff"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noticeList, item => {
      return _openBlock(), _createElementBlock("span", {
        key: item.id
      }, _toDisplayString(item.content), 1);
    }), 128))]),
    _: 1
  })])) : _createCommentVNode("", true), _createVNode(_component_van_swipe, {
    class: "my-swipe",
    autoplay: 3000,
    "indicator-color": "white"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "banner_item",
          onClick: $event => $setup.toDetails(item)
        }, [_createVNode(_component_my_image, {
          url: item.image_url
        }, null, 8, ["url"])], 8, _hoisted_3)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })], 64);
}